import React from 'react'
import Link from 'next/link'

import Footer, { SocialIcon } from '../Footer'
import { routes } from '../../routes'
import styles from './styles.module.scss'

export const FuneralHomeFooter: React.FC = () => {
  return (
    <div className="print-hide">
      <Footer.Wrapper>
        <Footer.Section>
          <Footer.Logo />
        </Footer.Section>

        <Footer.Section fill={true}>
          <Footer.Location>
            <Footer.Title>Kalas - Edgewater</Footer.Title>

            <Footer.Body>
              <a className={styles.location} href="https://maps.app.goo.gl/3yvDuiM2mF7KK3hN9">
                2973 Solomons Island Rd
              </a>
            </Footer.Body>

            <Footer.Body>
              <a className={styles.location} href="https://maps.app.goo.gl/3yvDuiM2mF7KK3hN9">
                Edgewater, MD 21037
              </a>
            </Footer.Body>

            <Footer.Body bold={true}>
              <a className={styles.tel} href="tel:4109564488">
                (410) 956-4488
              </a>
            </Footer.Body>
          </Footer.Location>

          <Footer.Location>
            <Footer.Title>Kalas - National Harbor</Footer.Title>

            <Footer.Body>
              <a className={styles.location} href="https://maps.app.goo.gl/9M843QGHrnL8PLyu6">
                6160 Oxon Hill Rd
              </a>
            </Footer.Body>

            <Footer.Body>
              <a className={styles.location} href="https://maps.app.goo.gl/9M843QGHrnL8PLyu6">
                Oxon Hill, MD 20745
              </a>
            </Footer.Body>

            <Footer.Body bold={true}>
              <a className={styles.tel} href="tel:3015679424">
                (301) 567-9424
              </a>
            </Footer.Body>
          </Footer.Location>

          <Footer.Right className={styles.right}>
            <Footer.SocialWrapper>
              <Footer.Social href="https://www.facebook.com/KalasFH" icon={SocialIcon.FACEBOOK} />

              <Footer.Social
                href="https://www.instagram.com/kalasfhc/?hl=en"
                icon={SocialIcon.INSTAGRAM}
              />
            </Footer.SocialWrapper>

            <div className={styles.bottomRight}>
              <Footer.Small>
                &copy;2025 Kalas Funeral Home &amp; Crematory. All rights reserved.
              </Footer.Small>

              <div className={styles.bottomRightInner}>
                <Footer.Small>
                  <Link href={routes.privacyPolicy}>
                    <a className={styles.link} rel="noopener" target="_blank">
                      Privacy Policy
                    </a>
                  </Link>
                </Footer.Small>

                <Footer.Small>
                  <Link href={routes.termsOfUse}>
                    <a className={styles.link} rel="noopener" target="_blank">
                      Terms of Use
                    </a>
                  </Link>
                </Footer.Small>

                <Footer.Small>
                  Site powered by{' '}
                  <Link href="https://getrevelry.com/">
                    <a className={styles.link} rel="noopener" target="_blank">
                      Revelry
                    </a>
                  </Link>
                </Footer.Small>
              </div>
            </div>
          </Footer.Right>
        </Footer.Section>
      </Footer.Wrapper>
    </div>
  )
}
